var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VxCurrencyInput',{staticClass:"input-text-border-none",on:{"blur":_vm.changeInput,"click":_vm.onClick,"input":_vm.onInput,"focus":_vm.onFocus},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }